module.exports = __webpack_public_path__ + "img/tx-confirmed.af89664a.svg";